import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { profileApi } from '../services/api';

function ProfileSetupPage() {
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();
  const defaultNickname = user?.email?.split('@')[0] ?? '';
  const [nickname, setNickname] = useState(user?.nickname || defaultNickname);
  const [zipcode, setZipcode] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const finalNickname = nickname.trim() || defaultNickname;
    if (!finalNickname) {
      setError('Nickname is required');
      return;
    }

    if (!/^\d{5}$/.test(zipcode)) {
      setError('Please enter a valid 5-digit US zipcode');
      return;
    }

    setSaving(true);
    try {
      await profileApi.updateProfile({ nickname: finalNickname, zipcode });
      updateUser({ nickname: finalNickname, zipcode });
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to save profile');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Welcome to StandLogic</h2>
        <p className="auth-subtitle">Set up your profile to get started</p>

        {error && <div className="alert alert-error" role="alert">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="nickname">Nickname</label>
            <input
              id="nickname"
              type="text"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              placeholder="What should we call you?"
              required={!defaultNickname}
              autoFocus={!defaultNickname}
            />
            <span className="form-hint">You can change this anytime on your Profile page</span>
          </div>

          <div className="form-group">
            <label htmlFor="zipcode">Hunting Zipcode</label>
            <input
              id="zipcode"
              type="text"
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value.replace(/\D/g, '').slice(0, 5))}
              placeholder="e.g., 21795"
              required
              autoFocus={!!defaultNickname}
              pattern="\d{5}"
              maxLength={5}
            />
            <span className="form-hint">Enter a 5-digit U.S. ZIP code. Canadian postal codes are not supported.</span>
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={saving}>
            {saving ? 'Saving...' : 'Get Started'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ProfileSetupPage;
